'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypeMap;

var _reactRouterRedux = require('react-router-redux');

var _intercomService = require('./intercomService');

var _elementCountSelector = require('../user/elementCount/elementCountSelector');

var _elementMoveActionUtil = require('../element/elementMoveActionUtil');

var _elementConstants = require('../../common/elements/elementConstants');

var _userConstants = require('../../common/users/userConstants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Analytics


// Constants


var trackNavigate = function trackNavigate(state, action) {
    var currentUserId = state.getIn(['app', 'currentUser', '_id']);
    var currentBoardId = state.getIn(['users', currentUserId, 'currentBoardId']);

    var sharedBoardUsers = state.get('users').filter(function (user) {
        return user.get('currentBoardId') === currentBoardId || user.get('_id') === currentUserId;
    });

    if (sharedBoardUsers.size >= 2) {
        (0, _intercomService.intercomTrackEvent)('live-shared-board', { users_count: sharedBoardUsers.size });
    }
};

var updateIntercom = function updateIntercom(state, action) {
    var billableContent = (0, _elementCountSelector.contentTotalCountSelector)(state);
    if (!billableContent) return (0, _intercomService.intercomUpdate)({});

    var contentLimit = (0, _elementCountSelector.contentTotalLimitSelector)(state);
    var contentRemaining = contentLimit - billableContent;

    (0, _intercomService.intercomUpdate)({ billable_content: billableContent, billable_content_remaining: contentRemaining });
};

var trackElementCreate = function trackElementCreate(state, action) {
    if (action.remote) return;
    (0, _intercomService.intercomTrackEvent)('created-' + action.elementType.toLowerCase());

    // request updated auto messages from intercom
    updateIntercom(state, action);
};

var trackMultiMoveToTrash = function trackMultiMoveToTrash(state, action) {
    if (action.moves.some(_elementMoveActionUtil.isMoveToOrFromTrash)) updateIntercom(state, action);
};

var actionTypeMap = (_actionTypeMap = {}, _defineProperty(_actionTypeMap, _userConstants.USER_NAVIGATE, trackNavigate), _defineProperty(_actionTypeMap, _reactRouterRedux.LOCATION_CHANGE, updateIntercom), _defineProperty(_actionTypeMap, _elementConstants.ELEMENT_CREATE, trackElementCreate), _defineProperty(_actionTypeMap, _elementConstants.ELEMENT_MOVE_MULTI, trackMultiMoveToTrash), _actionTypeMap);

exports.default = function (store) {
    return function (next) {
        return function (action) {
            var trackActionType = actionTypeMap[action.type];
            if (trackActionType) {
                trackActionType(store.getState(), action);
            }
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/analyticsEventMiddleware.js
// module id = 1661
// module chunks = 0